import { render, staticRenderFns } from "./SessionDetailsTab.vue?vue&type=template&id=6df62153&scoped=true&"
import script from "./SessionDetailsTab.vue?vue&type=script&lang=js&"
export * from "./SessionDetailsTab.vue?vue&type=script&lang=js&"
import style0 from "./SessionDetailsTab.vue?vue&type=style&index=0&id=6df62153&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df62153",
  null
  
)

export default component.exports